import React from 'react';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import Button from 'react-bootstrap/lib/Button';

const ShortlistButton = ({
  mobile,
  toggleShortlist,
  shortlistState,
  style,
}) => (
  <Button
    onClick={toggleShortlist}
    style={{
      ...style,
    }}
    className={`${mobile ? 'visible-xs' : 'hidden-xs'} btn btn-default`}
    title="Adds/Removes freelancer from your Talent Pool"
  >
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <SvgIcon
        icon="heart"
        size="18"
        color={shortlistState ? '#D9534F' : '#D3D3D3'}
      />
    </div>
  </Button>
);

export default ShortlistButton;
